import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const PageLoader = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '80vh',
        width: '100%',
        backgroundColor: 'transparent',
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        <CircularProgress 
          size={60} 
          thickness={4} 
          sx={{ 
            color: '#4F46E5', // Indigo 600
            mb: 3,
            '& .MuiCircularProgress-circle': {
              strokeLinecap: 'round',
            }
          }} 
        />
        <Typography 
          variant="h6" 
          sx={{ 
            color: '#0F172A', 
            fontWeight: 600, 
            letterSpacing: '0.05em' 
          }}
        >
          Loading...
        </Typography>
      </motion.div>
    </Box>
  );
};

export default PageLoader;
